<template>
  <div>
    <div class="sai-tagged-input" :class="{ onFocus: show }">
      <div class="sai-tagged-input__contents">
        <a
          class="sai-tagged-input__contents__tag"
          :class="tag.type === 'node' && 'category'"
          v-for="tag in selectedTags"
          :key="tag.id"
        >
          <span>{{ tag.displayText || tag.text }}</span>
          <a
            class="sai-tagged-input__contents__tag__close"
            @click.prevent="removeTag(tag)"
            ><img src="../resource/sai-icon_close_light_green.svg">
          </a>
        </a>
        <input
          class="sai-tagged-input__contents__input"
          type="text"
          size="1"
          :value="searchText"
          :placeholder="placeholderMessage"
          @input="updateSearchText($event.target.value)"
          @focus="onFocus"
          @keyup="keyupHandler"
          @keydown="keydownHandler"
          @keypress="onKeypress"
          @compositionstart="onCompositionStart"
          @compositionend="onCompositionEnd"
          ref="searchInput"
        />
      </div>
      <div class="sai-tagged-input__functions" v-show="show">
        <div
          class="sai-tagged-input__functions__calc"
          v-if="
            filteredItems.length > 0 && (selectedTags.length > 0 || searchText)
          "
        >
          <div class="sai-tagged-input__functions__calc__count">
            <span class="sai-tagged-input__functions__calc__count__num">
              {{ filteredItems.length }}
            </span>
            <span class="sai-tagged-input__functions__calc__count__text">
              件<span>{{ searchCalcText }}</span>
            </span>
          </div>
          <div class="sai-tagged-input__functions__calc__bar">
            <div class="sai-calc-bar" :style="{ width: barWidth + 'px' }">
              <span
                class="sai-calc-bar inner"
                :style="{
                  width: calcBarWidth(filteredItems.length) + 'px',
                }"
              ></span>
            </div>
          </div>
        </div>
        <div class="sai-tagged-input__functions__close">
          <a
            class="sai-tagged-input__functions__close__icon"
            @click.prevent="closeList"
          >
            <img src="../resource/sai-icon_close_gray.svg" />
          </a>
        </div>
      </div>
      <div class="sai-tagged-input__icon" v-show="!show">
        <img src="../resource/sai-icon_glass.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component';
import TaggedInputMixin from '@/mixins/TaggedInputMixin';
import Const from '../const/index';
import dataResource from '@/common/dataResource';
import talkScript from '@/common/talkScript';
import { eventBus } from '@/eventBus';

@Component({})
export default class TaggedInput extends mixins(TaggedInputMixin) {
  barWidth = 130;
  searchCalcText = Const.SEARCH_CALC_TEXT;

  get placeholderMessage() {
    return this.$store.state.tagSearch.selectedTags.values().length === 0
      ? Const.INITIAL_INPUT_MESSAGE
      : '';
  }
  calcBarWidth(count) {
    const length = count >= 100 ? this.barWidth : this.barWidth * (count / 100);
    return length > 2 ? length : 2;
  }
  async onFocus() {
    if (this.show) {
      return;
    }

    this.setShow(true);
    if (this.$store.state.user.isSP && !this.$store.state.user.isIphone) {
      setTimeout(() => {
        eventBus.$emit('scrollToTop');
      }, 0);
    }

    if (this.$store.state.ticket.resetFlag) {
      eventBus.$emit('resetTicket');
      return;
    }
    const newTicket = this.updateOpenTicket();
    await this.$ticket.setData(newTicket);
    this.$ticket.post();
  }
}
</script>

<style lang="scss" scoped>
@import '../style/settings';
@import '../style/component/searchBox';
@import '../style/setting/variable';

.sai-tagged-input {
  display: flex;
  justify-content: space-between;
  position: relative;
  border-radius: 6px;
  background-color: #fff;
  transition: box-shadow 0s ease 0.01s;
  min-height: 46px;

  .mobile & {
    padding: 0;
  }
  .pc & {
  }
  &.onFocus {
    box-shadow: 0px 14px 3px -10px #ccc;
    -webkit-box-shadow: 0px 14px 3px -10px #ccc;
    -moz-box-shadow: 0px 14px 3px -10px #ccc;
  }
  &__contents {
    flex: 1 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 8px 8px 3px 3px;

    &__tag {
      animation: tag-fade-in 0.2s;
      -ms-animation: tag-fade-in 0.2s;
      cursor: pointer;
      background-color: #333;
      color: #fff !important;
      border-radius: 3px;
      padding: 4px 6px 4px 9px;
      margin: 0px 0 5px 5px;
      pointer-events: none;
      font-size: 14px;
      font-weight: 600;
      font-family: $subFontFamily;
      text-decoration: none !important;

      .mobile & {
        display: flex !important;
        align-items: center !important;
        background-color: #333 !important;
        line-height: 22px;
        padding: 3px 5px 3px 8px;
        border: solid 1px transparent;
      }
      &:hover {
        background: #757575 !important;
        .mobile & {
          background-color: #333 !important;
        }
      }
      a {
        display: inline-block !important;
        cursor: pointer !important;
        pointer-events: auto !important;

        .mobile & {
          padding: 0px 0px 0px 3px !important;
        }

        img {
          display: inline-block;
          position: relative;
          top: 3px;
          width: 16px !important;
          height: 16px !important;
          opacity: 1 !important;
          transition: none !important;
        }
      }
      span {
        line-height: 22px;
        font-size: 14px;
        .mobile & {
          font-size: 12px;
        }
      }
      &.category {
        background-color: #ddd;
        &:hover {
          background-color: #eee;
        }

        span {
          color: #333;
        }
      }
    }
    @keyframes tag-fade-in {
      0% {
        transform: scale(1);
        opacity: 0;
        -ms-opacity: 0;
      }
      50% {
        transform: scale(1.05);
        opacity: 0.8;
        -ms-opacity: 0.8;
      }
      100% {
        transform: scale(1);
        opacity: 1;
        -ms-opacity: 1;
        zoom: 1;
      }
    }
    &__input {
      display: inline-block;
      margin: 3px 5px 6px 6px;
      line-height: 25px;
      min-height: 25px;
      border: none;
      flex: 1;
      box-sizing: border-box;
      .mobile & {
        font-size: 16px;
        margin: 2px 5px 7px 6px;
      }
      &:focus {
        outline: 0;
      }
      &::placeholder {
        color: #757575;
      }
      /* IE */
      &:-ms-input-placeholder {
        color: #757575;
      }
      /* Edge */
      &::-ms-input-placeholder {
        color: #757575;
      }
    }
    input[type='text']::-ms-clear {
      display: none;
    }
  }

  &__functions {
    display: flex;
    padding: 3px 8px 0 0;

    &__calc {
      text-align: right;

      .mobile & {
        margin: 10px 4px 0 0;
      }

      &__count {
        color: #62a70f;
        text-align: right;
        .mobile & {
          line-height: 21px;
        }

        &__num {
          display: inline-block;
          font-size: 16px;
          font-weight: bold;
          .mobile & {
            font-size: 14px;
          }
        }
        &__text {
          display: inline-block;
          font-size: 11px;
          .mobile & {
            font-size: 12px;
          }
          span {
            .mobile & {
              display: none;
            }
          }
        }
      }
      &__bar {
        padding-top: 2px;
        .mobile & {
          display: none;
        }
      }
    }

    &__close {
      display: inline-block !important;
      margin: 0 0 0 8px  !important;
      .mobile & {
        margin: 0 !important;
      }
      &__icon {
        display: flex !important;
        margin-top: 9px !important;
        padding: 3px !important;
        border-radius: 50% !important;
        background-color: #eee !important;
        cursor: pointer !important;

        img {
          width: 16px !important;
          height: 16px !important;
          transition: none !important;
          opacity: 1 !important;
          background-color: transparent !important;
        }
      }
    }
  }

  &__icon {
    display: inline-block;
    padding: 14px 10px 0 0;

    img {
      width: 19px;
      height: 17px;

      .mobile & {
        width: 18px;
        height: 16px;
      }
    }
  }
}

.sai-calc-bar {
  position: relative;
  height: 8px;
  background-color: #e8e8e8;
  background-size: 2px 2px;
  background-image: -webkit-gradient(
    linear,
    0 0,
    100% 0,
    color-stop(0.5, #fff),
    color-stop(0.5, transparent),
    to(transparent)
  );
  &.inner {
    display: block;
    position: absolute;
    right: 0;
    transition-duration: 0.5s;
    transition-delay: 0.7s;
    transition-property: width;
    background-color: #62a70f;
  }
}
// firefox
@-moz-document url-prefix() {
  .sai-calc-bar {
    -moz-background-size: 2px 2px !important;
    background-image: -moz-linear-gradient(
      left,
      #fff 50%,
      transparent 50%,
      transparent
    ) !important;
  }
}
// IE
@media all and (-ms-high-contrast: none) {
  *::-ms-backdrop,
  .sai-calc-bar {
    background-image: -ms-linear-gradient(
      left,
      #fff 50%,
      transparent 50%,
      transparent
    ) !important;
  }
}
</style>



// WEBPACK FOOTER //
// products/390/components/TaggedInput.vue